import useABTestValue from '@hooks/useABTestValue'

export type UseShowSharinglabels = () => boolean

const useShowSharingLabels: UseShowSharinglabels = () =>
  useABTestValue('showSharingLabel') === 'show'

export default useShowSharingLabels
